import clsx from "clsx";
import { ChevronLeftIcon } from "lucide-react";
import Link from "next/link";
import { useEffect, useState } from "react";

export interface BreadcrumbItem {
	name: string;
	href?: string;
	current?: boolean;
}

export type BreadcrumbsProps = {
	items?: BreadcrumbItem[];
	className?: string;
};

const Breadcrumbs = ({ items, className }: BreadcrumbsProps) => {
	const [hasPreviousRoute, setHasPreviousRoute] = useState<boolean>();

	useEffect(() => {
		if (history) {
			setHasPreviousRoute(history.length > 2);
		}
	}, []);

	return (
		<div
			className={clsx(
				"flex w-full items-center justify-center border-b bg-white phablet:px-3 px-3 py-2 shadow-transparent shadow-xl 2xl:px-10 dark:bg-slate-800",
				className,
			)}
		>
			<div className="flex w-full max-w-screen-2xl gap-2.5 phablet:gap-3">
				{hasPreviousRoute && (
					<>
						<button
							onClick={() => history.back()}
							className="group group -my-0.5 -ml-1 phablet:ml-0 flex max-w-max items-center gap-0.5 rounded-full py-0.5 font-medium phablet:text-sm"
						>
							<ChevronLeftIcon
								size={18}
								className="phablet:-ml-1 transition-transform group-hover:-translate-x-0.5"
								strokeWidth={2.4}
							/>
							Back
						</button>

						<div className="h-auto border-r" />
					</>
				)}

				<ol className="no-scrollbar flex items-center gap-0.5 phablet:gap-1.5 overflow-auto">
					{items?.map((item, i) => (
						<li key={item.name}>
							<div className="flex items-center">
								<svg
									className="h-5 w-5 flex-shrink-0 text-slate-700 dark:text-slate-100"
									xmlns="http://www.w3.org/2000/svg"
									fill="currentColor"
									viewBox="0 0 20 20"
									aria-hidden="true"
								>
									<path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
								</svg>
								<Link
									href={item.href ?? ""}
									className={clsx(
										`ml-0.5 phablet:ml-2 whitespace-nowrap text-sm hover:underline`,

										{
											"pointer-events-none": !item.href,
										},
										i === items.length - 1 ? "font-medium" : "font-normal",
									)}
									aria-current={i === items.length - 1 ? "page" : undefined}
								>
									{item.name}
								</Link>
							</div>
						</li>
					))}
				</ol>
			</div>
		</div>
	);
};

export default Breadcrumbs;
